module.exports = __webpack_public_path__ + "img/status-stop.fbcd0198.svg";